import { render } from "./pointListU.vue?vue&type=template&id=7427dcbe&scoped=true"
import script from "./pointListU.vue?vue&type=script&lang=js"
export * from "./pointListU.vue?vue&type=script&lang=js"

import "./pointListU.vue?vue&type=style&index=0&id=7427dcbe&scoped=true&lang=css"
import "@/styles/striNew.css?vue&type=style&index=1&lang=css"
import "./pointListU.vue?vue&type=style&index=2&id=7427dcbe&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-partnerpage-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7427dcbe"]])

export default __exports__